module.exports = __webpack_public_path__ + "static/img/3.53ffaa9.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/layer4/ban-th/3.jpg
// module id = ISJs
// module chunks = 1